<template>
	<section id="value-system" ref="container" :class="{
			step1: progress <= 0,
			step2: progress > 0,
			step3: progress >= 33,
			step4: progress >= 66,
			step5: progress === 100
		}">

		<div id="ertek">
			<h3 v-if="currentLanguage === 'hu'">Érték</h3>
			<p v-if="currentLanguage === 'hu'">Mindaz az emberi értéken alapuló minőségi gondolat, alkotás, létesítmény, módszer, amely képességeink és a fejlett technológiák alkalmazása által jön létre és fenntarthatóvá, jobbá teszi a világot.</p>
			<h3 v-if="currentLanguage === 'en'">Value</h3>
			<p v-if="currentLanguage === 'en'">Quality ideas, designs, buildings, methods created by our abilities and by applying advanced technologies and aiming at making the world sustainable and better.</p>
			<h3 v-if="currentLanguage === 'de'">Wert</h3>
			<p v-if="currentLanguage === 'de'">Alle Qualitätsideen, Schöpfungen, Projekte, Methoden, die, basierend auf menschlichem Wert, durch unsere Fähigkeiten und den Einsatz fortschrittlicher Technologien geschaffen werden und die Welt nachhaltiger, besser machen.</p>
		</div>

		<div id="rend">
			<h3 v-if="currentLanguage === 'hu'">Rend</h3>
			<p v-if="currentLanguage === 'hu'">Mindaz a módszer, digitális eszköztár, fejlett technológia, amellyel a folyamatokat rendszerré integrálva, tervezetten, átláthatóan vezetjük.</p>
			<h3 v-if="currentLanguage === 'en'">System</h3>
			<p v-if="currentLanguage === 'en'">The methods, digital tools, state of the art technologies we apply to turn processes into a planned and transparent system.</p>
			<h3 v-if="currentLanguage === 'de'">Ordnung</h3>
			<p v-if="currentLanguage === 'de'">Alle Methoden, digitale Mittel, fortschrittliche Technologien, mit denen wir Prozesse in ein System integriert, geplant und transparent steuern.</p>
		</div>

		<div id="ertekrend">
			<h3 v-if="currentLanguage === 'hu'">Értékrend</h3>
			<p v-if="currentLanguage === 'hu'">Erkölcsi-etikai elveink, melyek meghatározzák magatartásunkat és felelősségvállalásunkat a szakmánkban, a közösségben, a társadalomban, a gazdaságban és a természeti környezetünkben.</p>
			<h3 v-if="currentLanguage === 'en'">Value System</h3>
			<p v-if="currentLanguage === 'en'">Our moral and ethical principles that define our attitude in our profession, community, society, economy, and the natural environment.</p>
			<h3 v-if="currentLanguage === 'de'">Wertordnung</h3>
			<p v-if="currentLanguage === 'de'">Unsere moralischen und ethischen Grundsätze, die unser Verhalten und unser Verantwortungsbewusstsein in Beruf, Gemeinschaft, Gesellschaft, Wirtschaft und in unserer natürlichen Umwelt definieren.</p>
		</div>

		<div id="compass">
			<div id="traingle1"></div>
			<div id="traingle2"></div>
		</div>

	</section>
</template>

<script>

	export default {
		mounted() {
			setTimeout(() => {
				this.showText();
			}, 1000);
			window.addEventListener('scroll', this.onScroll);
		},
		computed: {
			currentLanguage() {
				return this.$route.params.lang || 'en';
			},
			progress() {
				var top = this.container.top - window.innerHeight / 2;
				var progress = (top < 0 ? ~top : 0) / this.container.height * 100;
				return progress > 100 ? 100 : progress;
			}
		},
		methods: {
			onScroll(event) {

				this.container = this.$refs.container.getBoundingClientRect();

			},
			showText() {

				var listItems = this.$refs.list
					? this.$refs.list.querySelectorAll('li')
					: [];

				function show(item, delay) {
					setTimeout(() => {
						item.classList.add('show');
					}, delay * 1500);
				}

				for (var i = 0; i < listItems.length; i++) {
					show(listItems[i], i);
				}

			}
		},
		data() {
			return {
				container: {}
			}
		}

	}
</script>

<style lang="scss" scoped>

	@import './../../../sass/variables';

	#value-system {
		position: relative;
		margin: 50vh 0;
		height: 200vh;

		@media screen and (max-width: $tablet-max) {
			height: auto;
			margin: 0;
		}
	}

	#compass {
		transform: translate(-50%, -50%) rotate(-30deg);
		transition: transform 500ms;
		transform-origin: 50% 50%;
		position: absolute;
		display: block;
		height: 200px;
		z-index: 9;
		width: 50%;
		left: 50%;
		top: 0;

		@media screen and (max-width: $tablet-max) {
			display: none;
		}

		&:after,
		&:before {
			transform: translate(-50%, -50%) scale(0);
			border-radius: 50%;
			position: absolute;
			display: block;
			height: 250px;
			width: 250px;
			content: '';
			z-index: 1;
			left: 50%;
			top: 50%;
		}

		&:after {
			.step4 & {
				transform: translate(-50%, -50%) scale(1);
				background-color: rgba(0,0,0,0.1);
			}
		}

		&:before {
			.step4 & {
				transform: translate(-50%, -50%) scale(1.2);
				border: 5px solid rgba(0,0,0,0.1);
			}
		}

		.step2 & {
			position: fixed;
			top: 50%;
		}

		.step4 & {
			transform: translate(-50%, 0%) rotate(-20deg);
		}

		.step5 & {
			transform: translate(-50%, -50%) rotate(-20deg);
			position: absolute;
			top: 100%;
		}
	}

		#traingle1,
		#traingle2 {
			position: absolute;
			height: 200px;
			width: 400px;
			z-index: 2;
			top: 0;

			&:before {
				transition: transform 500ms;
				border-width: 100px 200px;
				border-style: solid;
				position: absolute;
				display: block;
				content: '';
				height: 0;
				left: 50%;
				width: 0;
				top: 50%;
			}
		}

		#traingle1 {
			left: 50%;

			&:before {
				border-color: transparent transparent transparent $blue;
				transform: translate(20%, -50%) scale(0);
			}

			.step2 & {

				&:before {
					transform: translate(20%, -50%) scale(1);
				}
			}

			.step3 & {

				&:before {
					transform: translate(20%, -50%) scale(1);
				}
			}

			.step4 & {

				&:before {
					transform: translate(-50%, -50%) scale(1);
				}
			}
		}

		#traingle2 {
			right: 50%;

			&:before {
				border-color: transparent $light-blue transparent transparent;
				transform: translate(-120%, -50%) scale(0);
			}

			.step3 & {

				&:before {
					transform: translate(-120%, -50%) scale(1);
				}
			}

			.step4 & {

				&:before {
					transform: translate(-50%, -50%) scale(1);
				}
			}
		}

		#ertekrend,
		#ertek,
		#rend {
			transition: all 500ms;
			position: fixed;
			width: 30%;
			top: 55%;

			h3 {
				font-weight: bold;
			}

			p {
				font-size: 20px;
			}

			@media screen and (max-width: $tablet-max) {
				position: relative;
				top: initial;
				width: auto;
			}

			@media screen and (max-width: $mobile-max) {
				padding-right: 15px;
			}
		}

		#ertek {
			transform: translate(-20%, -100%);
			margin-top: -80px;
			opacity: 0;
			left: 45%;

			@media screen and (max-width: $tablet-max) {
				transform: translate(0);
				margin-bottom: 20px;
				margin-top: 0;
				opacity: 1;
				left: 0;
			}

			.step2 & {
				transform: translate(-50%, -100%) scale(1);
				opacity: 1;

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
				}
			}

			.step4 & {
				transform: translate(-50%, -100%) scale(0);

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
				}
			}
		}

		#rend {
			transform: translate(-70%, 0%) scale(1);
			text-align: right;
			opacity: 0;
			right: 20%;

			@media screen and (max-width: $tablet-max) {
				transform: translate(0);
				margin-bottom: 20px;
				text-align: left;
				right: initial;
				opacity: 1;
			}

			.step3 & {
				transform: translate(-50%, 0%) scale(1);
				opacity: 1;

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
				}
			}

			.step4 & {
				transform: translate(-50%, -100%) scale(0);

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
				}
			}
		}

		#ertekrend {
			transform: translate(-50%, -50%) scale(0);
			opacity: 0;
			left: 50%;
			top:46%;

			@media screen and (max-width: $tablet-max) {
				transform: translate(0);
				margin-bottom: 20px;
				left: initial;
				opacity: 1;
			}

			.step4 & {
				transform: translate(-50%, -120%) scale(1);
				opacity: 1;

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
				}
			}

			.step5 & {
				transform: translate(-50%, -500%) scale(1);
				opacity: 0;

				@media screen and (max-width: $tablet-max) {
					transform: translate(0);
					opacity: 1;
				}
			}
		}

</style>
